import styled from "styled-components";
import { Label } from "discover.medical.react-component-library";

export const Root = styled(Label)`
  font-size: ${({ theme }) => theme.font.size.sm};
  line-height: 1.25rem;
`;
